import wcShared from '@web-components/shared';

import { IReportingToolsCurrentGroup, IReportingToolsUser } from '../models/typing';

class ReportingToolsUserService {
  getUser(): Promise<{
    current_group: IReportingToolsCurrentGroup;
    user: IReportingToolsUser;
    autologged?: boolean;
  }> {
    return wcShared
      .httpCall('GET', '/api/components/profile/me?with=user,current_group')
      .then((r) => r.json())
      .then((user) => {
        return user.data;
      });
  }
}

export const UserService = new ReportingToolsUserService();
